import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import { XMLParser } from "fast-xml-parser";
import { toast } from "react-toastify";
const options = {
  ignoreAttributes: false,
  attributeNamePrefix: "@_",
  parseAttributeValue: false,
  parseTagValue: false,
};
const parser = new XMLParser(options);

export const getYearDataAPi = createAsyncThunk("/lookup=year", async () => {
  try {
    const response = await axios.get(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=year&id=VAP0204`);
    console.log(" this is year resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// make data api

export const getMakeDataAPi = createAsyncThunk("/lookup=make", async (year) => {
  try {
    const response = await axios.get(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=make&year=${year}&id=
VAP0204`);
    console.log(" this is make resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    console.log(" this is make jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// model data api
export const getModelDataAPi = createAsyncThunk("/lookup=model", async (data) => {
  try {
    // console.log(" this is make year  ", data.selectedMake, data.selectedYear);
    const response = await axios.get(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=model&year=${data.selectedYear}&make=${data.selectedMake}&id=VAP0204`);
    // console.log("url ", `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=model&year=${data.selectedYear}&make=${data.selectedMake}&id=VAP0204`);

    // console.log(" this is model resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    if (jsonData.ShowMeTheParts_Model.model.id === "") {
      toast.error("Model data not found");
    }
    console.log(" this is model jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// product lookup

export const getProductDataAPi = createAsyncThunk("/lookup=product", async (data) => {
  try {
    const response = await axios.get(
      `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=product&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`
    );
    console.log(" this is product resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    console.log(" this is product jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// part data api
export const getEngineDataAPi = createAsyncThunk("/lookup=engine", async (data) => {
  try {
    const response = await axios.get(
      `https://www.showmethepartsdb2.com/bin/ShowMeConnect.EXE?lookup=engine&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedProduct}&id=VAP0204`
    );
    console.log(
      "url",
      `https://www.showmethepartsdb2.com/bin/ShowMeConnect.EXE?lookup=engine&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedProduct}&id=VAP0204`
    );
    console.log(" this is part resp  resonse ", response);

    const jsonData = parser.parse(response.data);
    console.log(" this is part jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// get part type

export const getPartTypeApi = createAsyncThunk("/lookup=parttype", async (data) => {
  try {
    const response = await axios.get(
      `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parttype&engine=${data?.selectedEngine}&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&product=${data.selectedProduct}&id=VAP0204`
    );

    console.log(" this is part resp  resonse ", response);

    const jsonData = parser.parse(response.data);
    console.log(" this is part type  jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// get part list
export const getPartListDataAPi = createAsyncThunk("/lookup=partlist", async (data) => {
  try {
    let url = `https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=parts&year=${data.selectedYear}&make=${data.selectedMake}&model=${data.selectedModel}&id=VAP0204`;

    if (data.selectedProduct) {
      url += `&product=${data.selectedProduct}`;
    }

    if (data.selectedEngine) {
      url += `&engine=${data.selectedEngine}`;
    }
    console.log("url", url);
    const response = await axios.get(url);
    console.log(" this is part list resp  response ", response);
    const jsonData = parser.parse(response.data);
    console.log(" this is part list jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});

// get part list by id
export const getPartListByIdDataAPi = createAsyncThunk("/lookup=partlistbyid", async (data) => {
  try {
    const response = await axios.get(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=partdetailfull&part=${data}&id=VAP2182`);

    console.log(" this is single product  resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    console.log(" this is single product jsonData  ", jsonData);

    return jsonData;
  } catch (error) {
    throw error;
  }
});

// get part data by partno
export const getPartDataWithPartNOApi = createAsyncThunk("/lookup=partlist&partno", async (data) => {
  try {
    const response = await axios.post(`https://www.showmethepartsdb2.com/bin/ShowMeConnect.exe?lookup=partlist&partno=${data}&id=VAP0204`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(" this is part data by partno  resp  resonse ", response);
    const jsonData = parser.parse(response.data);
    console.log(" this is part data by partno jsonData  ", jsonData);
    return jsonData;
  } catch (error) {
    throw error;
  }
});
